export enum enmConfirmationStatus {
    Yes = 0,
    No = 1,
    Sent = 2,
    NotSent = 3,
    Wait = 4
}
